import pluralize from "pluralize"

import convertToSnakeCase from "@utils/convertToSnakeCase"

export interface GetObjectFiltersStorageKeyArgs {
    objectType: ObjectType
    objectTypeVariation?: string
    phase: ObjectPhase
    tab: string
}

/** The per-tab key for applied filters: the table and cards keys without their view segment. */
export default function getObjectFiltersStorageKey(args: GetObjectFiltersStorageKeyArgs) {
    const { objectType, phase, tab, objectTypeVariation } = args

    const objectTypePlural = pluralize(objectType)
    const snakeCaseTab = convertToSnakeCase(tab)

    return `${objectTypePlural}${
        objectTypeVariation ? "_" + convertToSnakeCase(objectTypeVariation) : ""
    }__${phase}_${snakeCaseTab}`
}
